<h1 class="{{heading}}">
  {{ title | translate }}
  <small>{{ subtitle | translate }}</small>
</h1>
